import { messageFromAxiosErrorPayload } from './axiosErrorMessage';

/**
 * Surfaces identity-verification `/api/identity-verification/v1/admin/dashboard/*` error bodies
 * (flat `{ error }` or `{ success: false, error: { message } }`) instead of Axios' generic 500 text.
 * Mirrors the employer-verification helper so both ops UIs format service errors consistently.
 */
export function messageFromIdentityVerificationHttpError(err: unknown): string {
  const ax = err as {
    message?: string;
    code?: string;
    response?: { status?: number; data?: unknown };
  };
  const msg = typeof ax.message === 'string' ? ax.message : '';
  if (ax.code === 'ECONNREFUSED' || msg.includes('ECONNREFUSED')) {
    return 'Cannot reach identity-verification on the proxy target. Start `npm run dev` in the `identity-verification` folder (default port 3001) or set VITE_IDENTITY_VERIFICATION_PROXY_TARGET in apps/admin/.env.';
  }
  if (ax.code === 'ERR_NETWORK' || msg === 'Network Error') {
    return 'Network error talking to identity-verification (CORS/offline/wrong port). Confirm the IV service is listening and the Vite proxy path /api/identity-verification is configured.';
  }
  const data = ax.response?.data;
  const parsed = messageFromAxiosErrorPayload(data);
  if (parsed) return parsed;
  if (data && typeof data === 'object') {
    const o = data as Record<string, unknown>;
    if (typeof o.error === 'string' && o.error.trim()) return o.error.trim();
  }
  return msg.trim() || 'Request failed.';
}
